import { WFComponent } from "@xatom/core";
import { gaEventTrigger } from "../../utils";

export const innovationProductPage = async () => {
    const shareButton = new WFComponent(`[xa-type="share-button"]`);
    const refineDesignButton = new WFComponent(`[xa-type="refine-design-button"]`);
    const consumerValidationButton = new WFComponent(`[xa-type="consumer-validation-link"]`);
    
    shareButton.on("click", () => {
        gaEventTrigger(window?.location?.pathname?.split("/")[2]?.replace(/-/g, " "), "IE-Concept: Share Button Clicked");
    });
    refineDesignButton.on("click", () => {
        gaEventTrigger(window?.location?.pathname?.split("/")[2]?.replace(/-/g, " "), "IE-Concept: Refine Design Button Clicked");
    });
    consumerValidationButton.on("click", () => {
        gaEventTrigger(window?.location?.pathname?.split("/")[2]?.replace(/-/g, " "), "IE-Concept: Consumer Validation Button Clicked");
    });
};